import React, { useContext, useState, useEffect } from 'react';
import clsx from 'clsx';
import _ from "lodash";

import {
    Typography,
    colors
} from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(2),
        color: colors.red[500]
    }
}));

export const FieldError = ({ name, errors, ...props }) => {
    const classes = useStyles();

    const [isVisible, setIsVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    useEffect(() => {
        if (errors
            && errors.length > 0
            && name !== null
            && name !== undefined
            && name.length > 0) {

            //console.debug(name);
            for (let i = 0; i < errors.length; i++) {
                const error = errors[i];
                let errorId = error.errorId;
                if (errorId.includes(".")) {
                    errorId = errorId.split(".").map(x => x.includes("[") ? x : _.camelCase(x)).join(".");
                } else {
                    errorId = _.camelCase(errorId);
                }
                let normalizedName = name;
                if (normalizedName.includes(".")) {
                    normalizedName = normalizedName.split(".").map(x => x.includes("[") ? x : _.camelCase(x)).join(".");
                } else {
                    normalizedName = _.camelCase(normalizedName);
                }
                //console.debug(`${errorId} -> ${_.camelCase(name)}`);
                if (errorId === normalizedName) {
                    setIsVisible(true);
                    setErrorMessage(error.message);
                    return;
                }
            }

            // No error to show
            setIsVisible(false);
            setErrorMessage(null);

        } else {
            // No error to show
            setIsVisible(false);
            setErrorMessage(null);
        }
    }, [errors, name])

    return (
        <>
            {isVisible &&
                <Typography variant="caption" component="span" gutterBottom className={clsx(classes.root, props.className)}>
                    {errorMessage}
                </Typography>
            }
        </>
    );
}
